import React, { useState } from 'react';
import { RESULTADOS, MOTIVOS } from '../utils/pedidosResultado';

// "¿Cómo terminó el pedido?" — se abre al marcar atendido (o al cambiar el
// resultado desde el Historial). No compró → pide el motivo.
export default function ResultadoPedidoModal({ pedido, guardando, onGuardar, onCerrar }) {
  const [resultado, setResultado] = useState(pedido.resultado || null);
  const [motivo, setMotivo] = useState(pedido.motivo || null);
  const [nota, setNota] = useState(pedido.nota_resultado || '');

  const listo = resultado && (resultado !== 'no_compro' || motivo);
  const chip = (activo) => ({
    padding: '7px 12px', borderRadius: '999px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
    border: `1px solid ${activo ? 'var(--color-primario,#DB2777)' : '#E5E7EB'}`,
    backgroundColor: activo ? 'var(--color-primario,#DB2777)' : 'white', color: activo ? 'white' : '#374151',
  });

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, background: 'rgba(20,10,30,.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Resultado del pedido"
        style={{ background: '#fff', borderRadius: '18px', width: '100%', maxWidth: '440px', maxHeight: '92vh', overflowY: 'auto', padding: '20px', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
          <b style={{ fontSize: '17px' }}>¿Cómo terminó este pedido?</b>
          <button onClick={onCerrar} aria-label="Cerrar" style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer' }}>✕</button>
        </div>
        <p style={{ margin: '0 0 14px', fontSize: '13px', color: '#6B7280' }}>
          {pedido.cliente_nombre} · {(pedido.prendas || [pedido]).map((x) => x.nombre_producto).join(', ')}
        </p>

        <div style={{ display: 'grid', gap: '8px', marginBottom: '14px' }}>
          {RESULTADOS.map((r) => (
            <button key={r.clave} onClick={() => setResultado(r.clave)}
              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 14px', borderRadius: '12px', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
                border: `2px solid ${resultado === r.clave ? r.color : '#ECE8F6'}`, backgroundColor: resultado === r.clave ? r.fondo : 'white' }}>
              <span style={{ fontSize: '20px' }}>{r.icono}</span>
              <span>
                <b style={{ fontSize: '14px', color: '#111827' }}>{r.etiqueta}</b><br />
                <small style={{ color: '#6B7280' }}>
                  {r.clave === 'compro' ? 'Se concretó la venta (regístrala en Vender)'
                    : r.clave === 'seguimiento' ? 'Le escribiste y estás esperando respuesta'
                      : 'Al final no se llevó nada'}
                </small>
              </span>
            </button>
          ))}
        </div>

        {resultado === 'no_compro' && (
          <div style={{ marginBottom: '14px' }}>
            <p style={{ margin: '0 0 8px', fontSize: '13px', fontWeight: 700, color: '#374151' }}>¿Por qué no compró?</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {MOTIVOS.map((m) => (
                <button key={m.clave} onClick={() => setMotivo(m.clave)} style={chip(motivo === m.clave)}>{m.etiqueta}</button>
              ))}
            </div>
          </div>
        )}

        {resultado && (
          <textarea value={nota} onChange={(e) => setNota(e.target.value.slice(0, 300))} rows={2}
            placeholder="Nota (opcional): ej. le escribo el viernes, quería otra talla…" aria-label="Nota del pedido"
            style={{ width: '100%', boxSizing: 'border-box', padding: '10px', borderRadius: '10px', border: '1px solid #D1D5DB', fontSize: '13px', fontFamily: 'inherit', marginBottom: '14px' }} />
        )}

        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button onClick={onCerrar} disabled={guardando} className="k-btn-soft">Cancelar</button>
          <button onClick={() => onGuardar({ resultado, motivo, nota })} disabled={!listo || guardando}
            style={{ padding: '9px 18px', borderRadius: '10px', border: 'none', fontWeight: 700, fontSize: '14px', fontFamily: 'inherit',
              backgroundColor: listo ? 'var(--k-verde,#059669)' : '#D1D5DB', color: 'white', cursor: listo ? 'pointer' : 'not-allowed' }}>
            {guardando ? 'Guardando…' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}
